import React from 'react'
import { checkTextTranslation, getObject } from '../../utils/useful'
import SelectInput from './SelectInput'

class NumberInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        // console.log(target.value)
        if (!target.value.includes('-') || target.value.lastIndexOf('-') == 0) {

            let value = (target.validity.valid) ? target.value : null
            let maxValue = this.props.header.information?.maxValue
            if (maxValue != null) {
                if (Number(value) > Number(maxValue)) {
                    return
                }
            }
            if (target.value == '-') {
                value = '-'
            } else {

                value = value != '' ? Number(value) : null
            }

            // console.log(value)
            if (!isNaN(value) || value == '-') {
                // console.log('maxValue', maxValue)
                // console.log('numbervalue', value != '' ? Number(value) : null)
                this.props.changeValue(this.props.header.key, value, this.props.extra)
            }
        }
    }

    changeUnitValue = (key, value, extra) => {
        this.props.changeValue(key, value, this.props.extra)
    }


    render() {


        let info = this.props.header.information
        let unit

        if (info.unit) {
            unit = getObject(this.props.fullData, info.unit?.key) ?? info.unit?.information?.defaultValue
        }

        let pattern = "^[-.,0-9]+$"
        if (info.negativeIsNotAllowed) {
            pattern = "^[.,0-9]+$"
        }
        // console.log(this.props.data)

        return (
            <div className="w-100 h-100 flexc">
                <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} pattern={pattern} step="0.01" value={this.props.data != null ? this.props.data : ''} maxLength={this.props.header.information.maxLength} onInput={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} className="transpanet-input" />

                {info.unit && (
                    <div className="flexcc px-1" style={{ width: 50, borderLeft: '1px solid #eee' }}>
                        <SelectInput header={info.unit} data={unit} changeValue={this.changeUnitValue} style={{ textAlign: 'center' }} />
                    </div>
                )}
            </div>
        )
    }
}

export default NumberInput;